import React from "react"

const Dashboard = () => (
  <div>
    <div className="jumbotron">
      <h1>Welcome to BISU ISMIS</h1>
      <h3>Faculty Module</h3>
      <hr />
      <div className="embed-responsive embed-responsive-16by9">
        <iframe
          className="embed-responsive-item"
          src="//slides.com/melvinsoldia/deck/embed?style=light"
        />
      </div>
    </div>
  </div>
)

export default Dashboard



// WEBPACK FOOTER //
// ./src/containers/Admin/Dashboard/index.js